exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-57899e23] {\n  margin-top: 70px;\n}\n.content-tlist[data-v-57899e23] {\n  background: none;\n  overflow: unset;\n}\n.content-table[data-v-57899e23] {\n  min-width: unset;\n}", ""]);

// exports
